<template>
    <form class="announcement-form form-horizontal" @submit.prevent="submit()">
        <div class="form-group" :class="{'has-error': errors['title']}">
            <label for="title" class="col-sm-2 control-label">Título</label>
            <div class="col-sm-10">
                <input type="text" class="form-control" id="title" v-model="data.title">
                <div class="help-block" v-for="e in errors['title']">{{e}}</div>
            </div>
        </div>        
        <div class="form-group" :class="{'has-error': errors['content']}">
            <label for="content" class="col-sm-2 control-label">Contenido</label>
            <div class="col-sm-10">
                <textarea class="form-control" id="content" v-model="data.content" rows="5"></textarea>
                <div class="help-block" v-for="e in errors['content']">{{e}}</div>
            </div>
        </div>
        <div class="form-group" :class="{'has-error': errors['url']}">
            <label for="url" class="col-sm-2 control-label">URL destino</label>
            <div class="col-sm-10">
                <input type="text" class="form-control" id="url" v-model="data.url">
                <div class="help-block" v-for="e in errors['url']">{{e}}</div>
            </div>
        </div>
        <div class="form-group" :class="{'has-error': errors['btn_text']}">
            <label for="btn_text" class="col-sm-2 control-label">Texto botón</label>
            <div class="col-sm-10">
                <input type="text" class="form-control" id="btn_text" v-model="data.btn_text">
                <div class="help-block" v-for="e in errors['btn_text']">{{e}}</div>
            </div>
        </div>
        <div class="form-group" :class="{'has-error': errors['tooltip']}">
            <label for="tooltip" class="col-sm-2 control-label">Texto ayuda botón</label>
            <div class="col-sm-10">
                <input type="text" class="form-control" id="tooltip" v-model="data.tooltip">
                <div class="help-block" v-for="e in errors['tooltip']">{{e}}</div>
            </div>
        </div>
        <div class="form-group" :class="{'has-error': errors['action']}">
            <label class="col-sm-2 control-label">Acción botón</label>
            <div class="col-sm-10">
                <div class="radio">
                    <label><input type="radio" v-model="data.action" :value="0" /> Nueva Pestaña</label></br>
                    <label><input type="radio" v-model="data.action" :value="1" /> Misma Ventana</label>
                </div>
                <div class="help-block" v-for="e in errors['action']">{{e}}</div>
            </div>
        </div>
        <div class="form-group" :class="{'has-error': errors['position']}">
            <label class="col-sm-2 control-label">Posición Anuncio</label>
            <div class="col-sm-10">
                <el-select filterable clearable v-model="data.position">
                    <el-option v-for="i in list" :key="i.value" :label="i.name" :value="i.value">
                        {{i.name}}
                    </el-option>
                </el-select>
                <div class="help-block" v-for="e in errors['position']">{{e}}</div>
            </div>
        </div>

        <div class="form-group" :class="{'has-error': errors['targeting']}">
            <label class="col-sm-2 control-label">Targeting</label>
            <div class="col-sm-10">
                <p>Gestione sus reglas de Targeting para el despliegue de los anuncios.</p>
                <div class="row">
                    <div class="col-sm-12">
                        <el-button @click="dialogFormVisible = true" icon="plus">Agregar Regla</el-button>

                        <el-dialog title="Agregar nueva regla" :visible.sync="dialogFormVisible">
                        <el-form :model="ruleForm" :rules="targetingRules" ref="ruleForm">
                            <el-form-item label="Regla" :label-width="formLabelWidth" prop="rule">
                                <el-select filterable clearable v-model="ruleForm.rule">
                                    <el-option v-for="i in rules" :key="i.value" :label="i.name" :value="i.value">
                                        {{i.name}}
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="Tipo" :label-width="formLabelWidth" prop="type">
                                <el-select filterable clearable v-model="ruleForm.type" :disabled="true">
                                    <el-option v-for="i in types" :key="i.value" :label="i.name" :value="i.value">
                                        {{i.name}}
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="Condición" :label-width="formLabelWidth" prop="condition">
                                <el-select filterable clearable v-model="ruleForm.condition">
                                    <el-option v-for="i in conditions" :key="i.value" :label="i.name" :value="i.value">
                                        {{i.name}}
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="Texto URL" :label-width="formLabelWidth" prop="value">
                                <el-input placeholder="Ingrese URL" v-model="ruleForm.value" autosize>
                                    <template slot="prepend">{{ host }}/</template>
                                </el-input>
                                <label><i>* Para incluir el Home, seleccione la Condición 'Coincide exacto con' e ingrese en Texto URL el caracter /</i></label>
                            </el-form-item>
                        </el-form>
                        <span slot="footer" class="dialog-footer">
                            <el-button @click="dialogFormVisible = false">Cancelar</el-button>
                            <el-button type="primary" @click="agregarRegla()">Agregar</el-button>
                        </span>
                        </el-dialog>
                    </div>
                </div>
                </br>
                <el-table :data="data.exclusions" style="width: 100%">
                    <el-table-column  label="Regla" >
                        <template slot-scope="scope">
                            <div v-for="r in rules"><div v-if="scope.row.rule == r.value">{{ r.name }}</div></div>
                        </template>
                    </el-table-column>
                    <el-table-column label="Tipo" >
                        <template slot-scope="scope">
                            <div v-for="t in types"><div v-if="scope.row.type == t.value">{{ t.name }}</div></div>
                        </template>
                    </el-table-column>
                    <el-table-column label="Condición" >
                        <template slot-scope="scope">
                            <div v-for="c in conditions"><div v-if="scope.row.condition == c.value">{{ c.name }}</div></div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="value" label="Valor" ></el-table-column>
                    <el-table-column label="Acción" >
                        <template slot-scope="scope">
                            <el-button
                            @click.native.prevent="deleteRow(scope.$index, data.exclusions)"
                            type="text"
                            size="small">
                            Remover
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="help-block" v-for="e in errors['exclusions']">{{e}}</div>
                <div><i>* Si no ingresa reglas de Targeting, el anuncio se desplegará en todo el sitio.</i></div>
            </div>
        </div>
        <div class="form-group" :class="{'has-error': errors['init_date']}">
            <label for="init_date" class="col-sm-2 control-label">Fecha Inicio</label>
            <div class="col-sm-10">                
                <el-date-picker
                    v-model="data.init_date"
                    type="date"
                    format="dd-MM-yyyy"
                    placeholder="Seleccione una Fecha">
                </el-date-picker>
                <div class="help-block" v-for="e in errors['init_date']">{{e}}</div>
            </div>
        </div>        
        <div class="form-group" :class="{'has-error': errors['exp_date']}">
            <label for="exp_date" class="col-sm-2 control-label">Fecha Fin</label>
            <div class="col-sm-10">
                <el-date-picker
                    v-model="data.exp_date"
                    type="date"
                    format="dd-MM-yyyy"
                    placeholder="Seleccione una Fecha">
                </el-date-picker>                
                <div class="help-block" v-for="e in errors['exp_date']">{{e}}</div>
            </div>
        </div>        

        <div class="form-group" :class="{'has-error': errors['active']}">
            <label class="col-sm-2 control-label">¿Activo?</label>
            <div class="col-sm-10">
                <div class="radio">
                    <label><input type="radio" v-model="data.active" :value="true" /> Si</label></br>
                    <label><input type="radio" v-model="data.active" :value="false" /> No</label>
                </div>
                <div class="help-block" v-for="e in errors['active']">{{e}}</div>
            </div>
        </div>
        <div class="form-group">
            <div class="col-sm-offset-2 col-sm-10">
                <a class="btn btn-default" @click="preview()">Previsualizar</a>                
            </div>
        </div>

        <div class="form-group">
            <div class="col-sm-offset-2 col-sm-10">
                <a class="btn btn-default" href="backend/anuncios">Cancelar</a>
                <button type="submit" class="btn btn-primary">Guardar</button>
            </div>
        </div>
        <vue-snotify></vue-snotify>
    </form>
</template>
<style lang="scss" scoped>
    .el-date-picker{
        display: block;
    }    
</style>
<script>
    import Vue from 'vue';
    import ElDatePicker from 'element-ui/lib/date-picker';
    import Snotify, { SnotifyPosition } from 'vue-snotify';
    import ElSelect from 'element-ui/lib/select';
    import ElOption from 'element-ui/lib/option';
    import ElTable from 'element-ui/lib/table';
    import ElButton from 'element-ui/lib/button';
    import ElTableColumn from 'element-ui/lib/table-column';
    import ElDialog from 'element-ui/lib/dialog';
    import ElForm from 'element-ui/lib/form';
    import ElFormItem from 'element-ui/lib/form-item';

    const options = {
        toast: {
            position: SnotifyPosition.leftBottom
        }
    }
    Vue.use(Snotify, options);
    
    var url2 = baseUrl;
    export default {
        data: function(){
            const data = {                
                id: null,
                title: null,
                content: '',
                image_path: null,
                url: '',
                btn_text: '',
                action: null,
                init_date: new Date(),
                exp_date: new Date(),
                active: null,
                show_title: null,
                template: null,
                created_at: null,
                updated_at: null,
                tooltip: '',
                position: '',
                exclusions: []
            };
            const list = [
                {"value": "leftTop", "name": "Esquina Superior Izquierda"},
                {"value": "leftCenter", "name": "Centrado a la Izquierda"},
                {"value": "leftBottom", "name": "Esquina inferior Izquierda"},
                {"value": "rightTop", "name": "Esquina Superior Derecha"},
                {"value": "rightCenter", "name": "Centrado a la Derecha"},
                {"value": "rightBottom", "name": "Esquina inferior Derecha"},
                {"value": "centerTop", "name": "Borde Superior al centro de la pantalla"},
                {"value": "centerCenter", "name": "Centro de la pantalla"},
                {"value": "centerBottom", "name": "Borde Inferior al centro de la pantalla"}
            ];
            const rules = [
                {"value": "include", "name": "Incluir"},
                {"value": "exclude", "name": "Excluir"}
            ];
            const conditions = [
                {"value": "has", "name": "Contiene"},
                {"value": "begins", "name": "Comienza con"},
                {"value": "ends", "name": "Termina con"},
                {"value": "equals", "name": "Coincide exacto con"},
            ];
            const types = [
                {"value": "URL", "name": "URL"},
                {"value": "path", "name": "Path"}
            ];

            var validateEmpty = (rule, value, callback) => {
                if (value === ''){
                    callback(new Error('Debe seleccionar una opción del listado.'));
                }else{
                    callback();
                }
            };
            var validateEmpty2 = (rule, value, callback) => {
                if (value === ''){
                    callback(new Error('Debe ingresar un valor.'));
                }else{
                    if(/\s/g.test(value)){
                        callback(new Error('No se admiten espacios.'));
                    }else if(value.charAt(0) == '/'){
                        if(value.length == 1 && this.ruleForm.condition == 'equals'){
                            callback();
                        }else{
                            callback(new Error('Texto no puede comenzar con "/".'));
                        }
                    }else if (_.includes(value, '//')){
                        callback(new Error('No se permite ingresar dos o más caracteres "/" consecutivos.'));
                    }else{
                        callback();
                    }
                }
            };
            
            return{
                data: _.assign(data, this.announcement),
                list: list,
                rules: rules,
                conditions: conditions,
                types: types,
                dialogFormVisible: false,
                disabled: false,
                errors: {},
                exclude: '',
                formLabelWidth: '120px',
                ruleForm: {
                    rule: '',
                    type: 'URL',
                    condition: '',
                    value: ''
                },
                host: url2,
                targetingRules: {
                    rule: [
                        { validator: validateEmpty, trigger: 'blur' }
                    ],
                    condition: [
                        { validator: validateEmpty, trigger: 'blur' }
                    ],
                    value: [
                        { validator: validateEmpty2, trigger: 'blur'}
                    ]
                }
            }
        },
        props: ['announcement','edit'], 
        components: {
            ElDatePicker,
            ElSelect,
            ElOption,
            ElTable,
            ElTableColumn,
            ElButton,
            ElDialog,
            ElForm,
            ElFormItem
        },
        created: function(){
            this.data.exclusions = JSON.parse(this.announcement.exclusions);
        },
        methods:{
            preview(){
                if (this.data.content == '' || this.data.url == '' || this.data.btn_text == '' || this.data.position == ''){
                    var req1 = (this.data.content == '') ? '\n- Contenido' : '';
                    var req2 = (this.data.url == '') ? '\n- URL destino' : '';
                    var req3 = (this.data.btn_text == '') ? '\n- Texto botón' : '';
                    var req4 = (this.data.position == '') ? '\n- Posición anuncio' : '';
                    alert('Debe completar los siguientes campos para previsualizar:\n'+req1+req2+req3+req4);
                }else{
                    var eltooltip = (this.data.tooltip) ? this.data.tooltip : '';
                    if (this.data.content.length > 150 || this.data.btn_text.length > 25 || eltooltip.length > 60){
                        var limit1 = (this.data.content.length > 150) ? '\n- Campo Contenido menor a 150 caracteres.' : '';
                        var limit2 = (this.data.btn_text.length > 25) ? '\n- Campo Texto botón menor a 25 caracteres.' : '';
                        var limit3 = (eltooltip.length > 60) ? '\n- Campo Texto ayuda botón menor a 60 caracteres.' : '';
                        alert('Lo siguientes campos deben cumplir con criterios definidos:\n'+limit1+limit2+limit3);
                    } else {
                        var final_url = (this.data.url.substr(0,4) != 'http') ? 'http://' + this.data.url : this.data.url;
                        var target = (this.data.action == 0) ? "_blank" : "_self";
                        if (this.data.tooltip){
                            var tooltip = (this.data.tooltip.length>0) ? 'data-toggle="tooltip" data-placement="top" title="'+ eltooltip +'"' : '';    
                        }else{
                            var tooltip = '';
                        }
                        
                        var html = `                    
                            <div class="col-xs-12 text-right" style="padding-right:0px;">
                                <a class="btn btn-default an_btn_close"><b>x</b></a>
                            </div>
                            <div class="media" style="margin-top:5px;margin-bottom:15px;">
                                <div class="media-left media-middle">
                                    <img src="images/familia.svg" class="media-object hidden-xs hidden-sm" style="width:110px">
                                </div>
                                <div class="media-body" style="padding-left:15px;">
                                    <p class="announcement_content">`+ this.data.content +`</p>
                                    <div style="text-align:center;margin:auto;">
                                            <a class="btn announcement_btn" href="`+ final_url +`" target="`+ target + `" `+ tooltip +`>`+this.data.btn_text+`</a>
                                    </div>
                                </div>
                            </div>                        
                        `;
                            
                        this.$snotify.html(html, {
                            timeout: 15000,
                            showProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            position: this.data.position
                        });
                    }
                }

            },
            deleteRow(index, rows) {
                rows.splice(index, 1);
            },
            agregarRegla(){
                var self = this;
                this.$refs['ruleForm'].validate((valid) => {
                    if (valid) {
                        if (!self.data.exclusions) {
                            self.data.exclusions = [];
                        }
                        self.data.exclusions.push({"rule":self.ruleForm.rule,"type":self.ruleForm.type,"condition":self.ruleForm.condition,"value":self.ruleForm.value})
                        self.dialogFormVisible = false;
                        this.$refs['ruleForm'].resetFields();
                    } else {
                        return false;
                    }
                });
            },
            addUrl(){
                var self = this;
                if(self.exclude == ''){
                    alert("Debe insertar una URL para agregar.")
                } else {
                    if (/\s/g.test(self.exclude)){
                        alert("Url ingresada no puede contener espacios.")
                        self.exclude = '';
                    }else{
                        if (_.find(self.data.exclusions, {"url":self.exclude})){
                            alert("Url ingresada ya está incluida");
                            self.exclude = '';
                        }else{
                            if (_.includes(self.exclude, '//')){
                                alert('No está permitido ingresar dos o más caracteres "/" consecutivos.');
                                self.exclude = '';
                            }else{
                                if (!self.data.exclusions) {
                                    self.data.exclusions = [];
                                }
                                var urlexcl = (self.exclude.charAt(0) != '/') ? '/' + self.exclude : self.exclude;
                                var urlexcl = (urlexcl.charAt(urlexcl.length - 1) === '/') ? urlexcl.slice(0,urlexcl.length-1) : urlexcl;
                                self.data.exclusions.push({"url": urlexcl});
                                self.exclude = '';
                            }
                        }
                    }
                }
            },
            submit: function(){
                var self = this;

                axios({
                    url: self.edit ? 'backend/anuncios/'+self.data.id : 'backend/anuncios',
                    method: self.edit ? 'PUT' : 'POST',
                    data: self.data,
                }).then(function(response){
                    window.location.replace(response.data.redirect);
                }).catch(function(error){
                    self.errors = error.response.data.errors;
                });
            }
        }
    }
</script>